import { render, staticRenderFns } from "./IconRewardMenuMyPoint.vue?vue&type=template&id=75167c3f"
import script from "./IconRewardMenuMyPoint.vue?vue&type=script&lang=js"
export * from "./IconRewardMenuMyPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports